import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { shopperDetails as TEXT } from 'locales/en/cart';
import { changeShopper } from 'redux/slices/checkout';

const ShopperInformation = () => {
  const dispatch = useDispatch();
  const shopperDetails = useSelector((state) => state.checkout.shopperDetails);
  const onClickChange = () => {
    dispatch(changeShopper());
  };

  return (
    <>
      <div
        data-testid="shopper-information"
        className="grid grid-cols-3 lg:flex lg:justify-between lg:p-5 lg:items-center items-start"
      >
        <div className="col-span-2 lg:flex lg:items-center lg:w-10/12">
          <h2
            data-testid="title"
            className="text-javelin-gray-dark text-sm lg:text-xs lg:text-opacity-40 lg:w-36"
          >
            {TEXT.title}
          </h2>
          <div
            data-testid="details"
            className="lg:flex lg:flex-row lg:w-9/12 overflow-ellipsis whitespace-nowrap overflow-hidden"
          >
            <p
              data-testid="name"
              className="text-sm text-javelin-gray-dark text-opacity-30 lg:text-opacity-100"
            >
              {`${shopperDetails.name} ${shopperDetails.surname}`}
            </p>
            <p
              data-testid="email"
              className="text-sm text-javelin-gray-dark text-opacity-30 lg:text-opacity-100 lg:ml-2"
            >
              {shopperDetails.email}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="text-sm text-javelin-blue-dark border-0 focus:outline-none text-right"
          onClick={onClickChange}
        >
          {TEXT.change}
        </button>
      </div>
      <hr className="horizontal-line w-screen -mx-3 lg:hidden" />
    </>
  );
};

export default ShopperInformation;
